import DcddMembershipTable from "./page/DcddMembershipTable";

const DcddMembershipPlan:React.FC = () => {
    return(
        <>
       <DcddMembershipTable/>
        </>
    )
};
export default DcddMembershipPlan;